// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Layout */
#home .ui.message .content .description {
  margin-top: 15px;
}

#home .ui.message .button {
  margin-top: 10px;
}

#mobile-layout #home {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

#mobile-layout #home > div {
  margin-left: 8px !important;
  margin-right: 8px !important;
}

#mobile-layout #home .ui.message {
  margin-top: 10px;
}

#mobile-layout .react-grid-layout {
  margin-top: 0px;
  margin-bottom: 25px;
}

/* Widgets */
.react-grid-layout .widget .main.content {
  max-height: calc(100% - 45px);
  display: flex;
  overflow: hidden;
}

.react-grid-layout .widget .main.content > div {
  max-height: 100%;
  max-width: 100%;
  display: flex;
  width: 100%;
  flex: 1;
}

.react-grid-layout .widget .header i.large.icon {
  font-size: 1.3em !important;
}

.react-grid-layout .widget .header-row {
  display: flex;
  flex: 0 0 auto !important;
}

.react-grid-layout .widget .header-row .header {
  flex: 1;
  height: 100%;
}

.react-grid-layout .widget .main.content .extra.content {
  opacity: 0.4;
}

#mobile-layout .react-grid-layout .react-grid-item {
  /* Allow touch scrolling */
  touch-action: initial !important;
  margin-left: 0px !important;
  margin-right: 0px !important;
}
`, "",{"version":3,"sources":["webpack://./src/routes/Home/style.css"],"names":[],"mappings":"AAAA,WAAW;AACX;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,6BAA6B;EAC7B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,WAAW;EACX,OAAO;AACT;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,2BAA2B;EAC3B,4BAA4B;AAC9B","sourcesContent":["/* Layout */\n#home .ui.message .content .description {\n  margin-top: 15px;\n}\n\n#home .ui.message .button {\n  margin-top: 10px;\n}\n\n#mobile-layout #home {\n  height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n#mobile-layout #home > div {\n  margin-left: 8px !important;\n  margin-right: 8px !important;\n}\n\n#mobile-layout #home .ui.message {\n  margin-top: 10px;\n}\n\n#mobile-layout .react-grid-layout {\n  margin-top: 0px;\n  margin-bottom: 25px;\n}\n\n/* Widgets */\n.react-grid-layout .widget .main.content {\n  max-height: calc(100% - 45px);\n  display: flex;\n  overflow: hidden;\n}\n\n.react-grid-layout .widget .main.content > div {\n  max-height: 100%;\n  max-width: 100%;\n  display: flex;\n  width: 100%;\n  flex: 1;\n}\n\n.react-grid-layout .widget .header i.large.icon {\n  font-size: 1.3em !important;\n}\n\n.react-grid-layout .widget .header-row {\n  display: flex;\n  flex: 0 0 auto !important;\n}\n\n.react-grid-layout .widget .header-row .header {\n  flex: 1;\n  height: 100%;\n}\n\n.react-grid-layout .widget .main.content .extra.content {\n  opacity: 0.4;\n}\n\n#mobile-layout .react-grid-layout .react-grid-item {\n  /* Allow touch scrolling */\n  touch-action: initial !important;\n  margin-left: 0px !important;\n  margin-right: 0px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
